import { createContext, useContext } from 'react'
import type { OwnerEvent } from '../api/ownerTypes'

export interface EventSession {
  subject: OwnerEvent

  /** Opnieuw ophalen na een wijziging; alle schermen delen dezelfde query. */
  refresh: () => Promise<void>
}

export const EventContext = createContext<EventSession | null>(null)

export function useEvent(): EventSession {
  const session = useContext(EventContext)

  if (!session) {
    throw new Error('useEvent hoort binnen een <EventLayout>.')
  }

  return session
}
